/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelFile = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--file holds--data isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div role="select" class="panel--content">'+
                    '            <form class="dropzone needsclick">'+
                    '            </form>'+
                    '        </div>'+
                    '        {% button %}'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var button = '<div class="panel--done">'+
                    '   <button type="submit" class="done--button" aria-label="{% go_button_text %}" disabled>'+
                    '        <div class="button--arrow"></div>'+
                    '   </button>'+
                    '</div>';

        return {'base': base, 'button': button};
    },
    attach: function() {
        // week start from Monday
        var meta = Object.clone(this.data.meta);
        var container = this.element.getElements(".panel--content .dropzone")[0];
        var Done = this.element.getElements('.done--button');
        var config = {
            dictCancelUpload: this.data.i18n.step.file.cancelUpload,
            dictDefaultMessage: this.data.i18n.step.file.defaultMessage,
            dictFallbackMessage: this.data.i18n.step.file.fallbackMessage,
            dictFallbackText: this.data.i18n.step.file.fallbackText,
            dictFileTooBig: this.data.i18n.step.file.fileTooBig,
            dictInvalidFileType: this.data.i18n.step.file.invalidFileType,
            dictUploadCanceled: this.data.i18n.step.file.uploadCanceled,
            dictCancelUploadConfirmation: this.data.i18n.step.file.cancelUploadConfirmation,
            dictRemoveFile: this.data.i18n.step.file.removeFile,
            dictRemoveFileConfirmation: this.data.i18n.step.file.removeFileConfirmation,
            dictMaxFilesExceeded: this.data.i18n.step.file.maxFilesExceeded,
            dictFileSizeUnits: this.data.i18n.step.file.fileSizeUnits,
            dictResponseError: this.data.i18n.step.file.responseError,
            addRemoveLinks: true,
            maxFiles: this.data.choices || null,
            maxFilesize: meta.max_length || 25, // same as on Facebook
            acceptedFiles: meta.fileAccepted && meta.fileAccepted.toString(),
            accept: function(file, done) {
                var uploadUrl = this.quriobot.getBotOption("uploadUrl")
                this.quriobot.ajax(uploadUrl, function(responseText) {
                    var response = JSON.parse(responseText)
                    file.response = response
                    done()
                }, {
                    id: this.quriobot.responseId,
                    name: file.name,
                    type: file.type
                })
            }.bind(this),
            params: function(files, xhr, chunk) {
                var params = files[0].response.params
                // if (chunk) {
                //     params.dzuuid = chunk.file.upload.uuid
                //     params.dzchunkindex = chunk.index
                //     params.dztotalfilesize = chunk.file.size
                //     params.dzchunksize = chunkSize
                //     params.dztotalchunkcount = chunk.file.upload.totalChunkCount
                //     params.dzchunkbyteoffset = chunk.index * chunkSize
                // }
                delete params.url
                params["Content-Type"] = files[0].type
                return params
            }.bind(this),
            url: function(files) {
                return files[0].response.params.url
            }.bind(this)
        }
        this.dropzone = new Dropzone(container, config);
        this.dropzone.on("queuecomplete", function() {
            Done.set("disabled", !this.validate())
        }.bind(this))
        this.dropzone.on("removedfile", function() {
            Done.set("disabled", !this.validate())
        }.bind(this))
        this.dropzone.on("maxfilesexceeded", function(file) {
            this.dropzone.removeFile(file);
        }.bind(this))
        this.dropzone.on("maxfilesreached", function(files) {
            files.slice(config.maxFiles).forEach(function(file){
                this.dropzone.removeFile(file);
            }.bind(this))
        }.bind(this))
        if(Done.length){
            Done.set("disabled", !this.validate())
            Done.each(function(oDone,i){
                oDone.addEvents({
                    click:function(){
                        if(this.validate()){
                            this.after();
                        }
                    }.bind(this)
                });
            }.bind(this));
        }
    },
    validate: function() {
        return this.dropzone.getAcceptedFiles().length || this.data.is_required === false
    },
    after: function(answer){
        var value = this.dropzone.getAcceptedFiles().map(function(item) {
            return [item.response.id, item.response.name, item.response.url];
        }).flatten();
        var text = this.dropzone.getAcceptedFiles().map(function(item) {
          return item.name
        }).join(", ");

        // Add `aria-hidden="true"` after answering to the question
        this.setAriaHidden('.panel--content', true);

        // Remove `aria-hidden="true"` from redo-button
        this.setAriaHidden('.icon--redoWrapper', false);

        this.element.addClass('isAnswered');
        this.answerCallback(this.data, {
            answer:{
                'value': value,
                'content': text,
                'render': false
            }
        });
        this.foldOutClose();
    }
});
